module.exports = "/_next/static/files/3926368101204aaffb98b5aa2a381ee0.png";